import { gql } from '@apollo/client';

export const GET_DAILY_TASK_DETAIL_BY_STATUS_FIELD = gql`
  query GetDetailsByStatusField(
    $taskDate: String!
    $statusFields: [String!]
    $pageRequest: DailyTaskPageRequestTypeInput!
    $warehouseId: Long
    $warehouseIds: [Long!]
    $hubId: Long
    $dspIds: [Long!]
    $areaIds: [Long!]
    $driverIds: [Long!]
    $cityNames: [String!]
  ) {
    getDetailsByStatusField(
      taskDate: $taskDate
      statusFields: $statusFields
      pageRequest: $pageRequest
      warehouseId: $warehouseId
      warehouseIds: $warehouseIds
      hubId: $hubId
      dspIds: $dspIds
      areaIds: $areaIds
      driverIds: $driverIds
      cityNames: $cityNames
    ) {
      content {
        id
        taskDate
        warehouseId
        dspId
        dspName
        areaId
        areaName
        driverId
        deliveryDriverId
        driverName
        trackingNumber
        orderId
        cityName
        currentStatus
        overallStatusText
        lastFailureReason
        exceptionReasonCode
        latestPhysicalTrackingUpdatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_DAILY_TASK_DETAIL_BY_STATUS_FIELD_FOR_DRIVER = gql`
  query GetDetailsByStatusFieldForDriver(
    $taskDate: String!
    $statusFields: [String!]
    $pageRequest: DailyTaskPageRequestTypeInput!
    $warehouseId: Long
    $warehouseIds: [Long!]
    $dspIds: [Long!]
    $areaIds: [Long!]
    $driverIds: [Long!]
    $cityNames: [String!]
  ) {
    getDetailsByStatusFieldForDriver(
      taskDate: $taskDate
      statusFields: $statusFields
      pageRequest: $pageRequest
      warehouseId: $warehouseId
      warehouseIds: $warehouseIds
      dspIds: $dspIds
      areaIds: $areaIds
      driverIds: $driverIds
      cityNames: $cityNames
    ) {
      content {
        id
        taskDate
        warehouseId
        dspId
        dspName
        areaId
        areaName
        driverId
        deliveryDriverId
        driverName
        trackingNumber
        orderId
        cityName
        currentStatus
        overallStatusText
        lastFailureReason
        exceptionReasonCode
        latestPhysicalTrackingUpdatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
